<template>
  <div class="item-position trend-common">
    <div>电流负荷</div>
    <div id="boxMetric"/>
  </div>
</template>

<script>
import G2 from '@antv/g2'
export default {
  name: 'CurrentBoxMetric',
  data () {
    return {
      chart: null
    }
  },
  props: {
    data: {
      type: Array
    }
  },
  watch: {
    data (val, oldVal) {
      if (val !== oldVal) {
        this.chart.source(val)
        this.chart.repaint()
      }
    }
  },
  methods: {
    initChart () {
      this.chart = new G2.Chart({
        container: 'boxMetric',
        width: 300,
        height: 210,
        padding: [ 10, 10, 20, 40 ]
      })
      this.chart.axis('value', {
        grid: null
      })
      this.chart.tooltip({
        'g2-tooltip': {
          border: '1px solid rgb(73, 213, 243)',
          backgroundColor: ' rgba(0, 0, 0, 0.8)',
          color: 'rgb(255, 255, 255)',
          boxShadow: 'rgb(73, 213, 243) 0px 0px 3px'
        }
      })
      this.chart.axis('name', {
        line: {
          stroke: '#545454'
        },
        tickLine: {
          stroke: '#545454'
        }
      })
      this.chart.legend(false)
      this.chart.intervalStack()
        .position('name*value')
        .color('type')
        .tooltip('type*value', (type, value) => {
          return {
            name: type,
            value: value + '%'
          }
        })
      this.chart.render()
    }
  },
  mounted () {
    this.initChart()
  }
}
</script>

<style scoped lang="scss">
  .trend-common {
    display: flex;
    align-items: center;
    left: 1610px;
    top: 660px;
    div:first-child{
      width: 20px;
      color: #abacad;
      font-size: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CurrentBoxMetric.vue